(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 5533:
/***/ (() => {



/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Spacing)
});

;// external "@babel/runtime/helpers/defineProperty"
const defineProperty_namespaceObject = require("@babel/runtime/helpers/defineProperty");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_namespaceObject);
;// external "@babel/runtime/helpers/toConsumableArray"
const toConsumableArray_namespaceObject = require("@babel/runtime/helpers/toConsumableArray");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_namespaceObject);
;// external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_namespaceObject);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/Spacing/Spacing.tsx



var _excluded = ["className", "top", "topVXS", "topVSM", "topVMD", "topVLG", "bottom", "bottomVXS", "bottomVSM", "bottomVMD", "bottomVLG", "left", "leftVXS", "leftVSM", "leftVMD", "leftVLG", "right", "rightVXS", "rightVSM", "rightVMD", "rightVLG", "children", "verticalSpacingAlias", "verticalSpacingType", "verticalSpacingPosition"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


/**
 * The spacing scale has been designed to provide consistency and render harmonious visual displays
 *
 * @version 1.0.0
 * @param props
 */
function Spacing(props) {
  var className = props.className,
    top = props.top,
    topVXS = props.topVXS,
    topVSM = props.topVSM,
    topVMD = props.topVMD,
    topVLG = props.topVLG,
    bottom = props.bottom,
    bottomVXS = props.bottomVXS,
    bottomVSM = props.bottomVSM,
    bottomVMD = props.bottomVMD,
    bottomVLG = props.bottomVLG,
    left = props.left,
    leftVXS = props.leftVXS,
    leftVSM = props.leftVSM,
    leftVMD = props.leftVMD,
    leftVLG = props.leftVLG,
    right = props.right,
    rightVXS = props.rightVXS,
    rightVSM = props.rightVSM,
    rightVMD = props.rightVMD,
    rightVLG = props.rightVLG,
    children = props.children,
    verticalSpacingAlias = props.verticalSpacingAlias,
    _props$verticalSpacin = props.verticalSpacingType,
    verticalSpacingType = _props$verticalSpacin === void 0 ? 'margin' : _props$verticalSpacin,
    _props$verticalSpacin2 = props.verticalSpacingPosition,
    verticalSpacingPosition = _props$verticalSpacin2 === void 0 ? 'bottom' : _props$verticalSpacin2,
    other = objectWithoutProperties_default()(props, _excluded);
  var patternClass = 'able-Spacing';
  var getSpacingAliasClass = function getSpacingAliasClass() {
    var spacingAliasClass = '';
    if (verticalSpacingAlias) {
      spacingAliasClass = "".concat(patternClass, "--").concat(verticalSpacingAlias, "--").concat(verticalSpacingType, "-").concat(verticalSpacingPosition);
    }
    return spacingAliasClass;
  };
  var getClassNames = function getClassNames() {
    var spacingClasses = ["".concat(top ? "".concat(patternClass, "--top--").concat(top) : ''), "".concat(topVXS ? "".concat(patternClass, "--top--").concat(topVXS, "--vxs") : ''), "".concat(topVSM ? "".concat(patternClass, "--top--").concat(topVSM, "--vsm") : ''), "".concat(topVMD ? "".concat(patternClass, "--top--").concat(topVMD, "--vmd") : ''), "".concat(topVLG ? "".concat(patternClass, "--top--").concat(topVLG, "--vlg") : ''), "".concat(bottom ? "".concat(patternClass, "--bottom--").concat(bottom) : ''), "".concat(bottomVXS ? "".concat(patternClass, "--bottom--").concat(bottomVXS, "--vxs") : ''), "".concat(bottomVSM ? "".concat(patternClass, "--bottom--").concat(bottomVSM, "--vsm") : ''), "".concat(bottomVMD ? "".concat(patternClass, "--bottom--").concat(bottomVMD, "--vmd") : ''), "".concat(bottomVLG ? "".concat(patternClass, "--bottom--").concat(bottomVLG, "--vlg") : ''), "".concat(left ? "".concat(patternClass, "--left--").concat(left) : ''), "".concat(leftVXS ? "".concat(patternClass, "--left--").concat(leftVXS, "--vxs") : ''), "".concat(leftVSM ? "".concat(patternClass, "--left--").concat(leftVSM, "--vsm") : ''), "".concat(leftVMD ? "".concat(patternClass, "--left--").concat(leftVMD, "--vmd") : ''), "".concat(leftVLG ? "".concat(patternClass, "--left--").concat(leftVLG, "--vlg") : ''), "".concat(right ? "".concat(patternClass, "--right--").concat(right) : ''), "".concat(rightVXS ? "".concat(patternClass, "--right--").concat(rightVXS, "--vxs") : ''), "".concat(rightVSM ? "".concat(patternClass, "--right--").concat(rightVSM, "--vsm") : ''), "".concat(rightVMD ? "".concat(patternClass, "--right--").concat(rightVMD, "--vmd") : ''), "".concat(rightVLG ? "".concat(patternClass, "--right--").concat(rightVLG, "--vlg") : '')];
    var classList = [patternClass];
    var spacingAliasClass = getSpacingAliasClass();
    if (spacingAliasClass) {
      classList.push(spacingAliasClass);
    } else {
      classList.push.apply(classList, spacingClasses);
    }
    if (className) {
      classList.push.apply(classList, toConsumableArray_default()(className));
    }
    return classList;
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", _objectSpread(_objectSpread({
    className: classnames_default()(getClassNames())
  }, other), {}, {
    children: children
  }));
}
Spacing.displayName = 'Spacing';
/* harmony default export */ const Spacing_Spacing = (Spacing);
// EXTERNAL MODULE: ./src/Spacing/Spacing.scss
var src_Spacing_Spacing = __webpack_require__(5533);
;// ./src/Spacing/index.ts


/* harmony default export */ const src_Spacing = (Spacing_Spacing);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});